import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TopicType } from 'src/app/enums/topic-type.enum';
import { CommentConfig } from 'src/app/models/comment-config.model';
import { Comment } from 'src/app/models/comment.model';
import { CommentDialogData } from 'src/app/models/dialog/comment-dialog-data.model';
import { GoalPeriod } from 'src/app/models/goalperiod.model';
import { State } from 'src/app/models/state.model';
import { StateService } from 'src/app/services';
import { CommentService } from 'src/app/services/comment.service';

@Component({
  selector: 'app-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrl: './comment-dialog.component.scss'
})
export class CommentDialogComponent {

  public state: State;
  public config: CommentConfig;
  public comment: Comment;
  public noSave?: boolean;

  public get comments() {
    return this.comment ? [this.comment] : [];
  }

  constructor(
    public dialogRef: MatDialogRef<CommentDialogComponent>,
    stateService: StateService,
    private commentService: CommentService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: CommentDialogData
  ) {
    this.state = stateService.state;
    this.comment = data.comment ?? { topicId: data.topicId, topicRef: data.topicRef, employeeId: this.state.me.value.employee.id} as Comment;
    this.noSave = data.noSave;
    this.config = this.createCommentConfig(data);
  }

  createCommentConfig(dialogData: CommentDialogData): CommentConfig {
        return {
            employeeId: this.state?.me.value?.employee?.id ?? 0,
            topicId: dialogData.topicId,
            topicRef: dialogData.topicRef,     // assessmentId
            author: this.state.me.value.employee?.name
        } as CommentConfig;
  }

  public onOk() {
    this.saveComment(this.comment);  
  }

  saveComment(comment: Comment) {
      if (comment.message === undefined) return;

      if (this.noSave)
      {
        this.dialogRef.close(comment);
        return;
      }

      if (!comment.message) {
        this.commentService.deleteComment(comment.id).subscribe({ next: () => {
            this.dialogRef.close(comment);
        }, error: (err) => {
            if (confirm(this.translate.instant('COMMENT_DIALOG.DELETE_ERROR'))) {
                this.saveComment(comment);
            }
            console.log(err);
        }});
      }
      else
      {
        const action = comment.id ? this.commentService.updateComment.bind(this.commentService) : this.commentService.insertComment.bind(this.commentService);
  
        action(comment).subscribe({ next: (result) => {
            comment.id = result.data.id;
            this.dialogRef.close(comment);
        }, error: (err) => {
            if (confirm(this.translate.instant('COMMENT_DIALOG.SAVE_ERROR'))) {
                this.saveComment(comment);
            }
            console.log(err);
        }});
      }


  };
  
}
